import {
  shouldShowPwaPrompt,
  setPwaDismissed,
  setPwaInstalled,
  promptInstall,
  getDeferredPrompt,
  isIos,
  isStandalone,
} from '../utils/pwa.js';

export function maybeShowPwaPrompt() {
  if (!shouldShowPwaPrompt() || isStandalone()) return null;

  const existing = document.getElementById('pwa-banner');
  if (existing) return existing;

  const banner = document.createElement('div');
  banner.id = 'pwa-banner';
  banner.className = 'pwa-banner';

  const ios = isIos();
  const canPrompt = !!getDeferredPrompt();

  banner.innerHTML = `
    <h4>添加到主屏幕</h4>
    <p>${
      ios
        ? '在 Safari 中点击分享按钮，然后选择「添加到主屏幕」，即可像 App 一样使用 GSORG。'
        : canPrompt
          ? '将 GlobalSchoolOrganization 安装到设备，离线也能打开，体验更接近原生应用。'
          : '通过浏览器菜单选择「安装应用」或「添加到主屏幕」，即可像 App 一样使用。'
    }</p>
    <div class="pwa-banner-actions">
      ${canPrompt && !ios ? `<button type="button" class="btn btn-primary btn-sm" id="pwa-install">立即安装</button>` : ''}
      <button type="button" class="btn btn-ghost btn-sm" id="pwa-dismiss">稍后再说</button>
    </div>
  `;

  document.body.appendChild(banner);

  banner.querySelector('#pwa-dismiss')?.addEventListener('click', () => {
    setPwaDismissed();
    banner.remove();
  });

  banner.querySelector('#pwa-install')?.addEventListener('click', async () => {
    const result = await promptInstall();
    if (result.outcome === 'accepted') {
      setPwaInstalled();
      banner.remove();
    } else if (result.outcome === 'unavailable') {
      setPwaDismissed();
      banner.remove();
    }
  });

  // If install prompt becomes available later, refresh button
  const onInstallable = () => {
    if (!document.getElementById('pwa-banner')) return;
    maybeShowPwaPrompt();
    banner.remove();
    maybeShowPwaPrompt();
  };
  window.addEventListener('gsorg:installable', onInstallable, { once: true });
  window.addEventListener('gsorg:installed', () => banner.remove(), { once: true });

  return banner;
}

export function hidePwaPrompt() {
  document.getElementById('pwa-banner')?.remove();
}
